var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"closeButton",on:{"click":_vm.cancel}},[_c('i',{staticClass:"fas fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }